import { FEATURE_NAME } from './consts';

export const CREATE_KKM = `${FEATURE_NAME}/CREATE_KKM`;
